import { TApiResponse } from '@/common/types/response';

import { calculateDynamic, setRegionDashboardsLocalStorage } from '../../utils/localStorage';
import { TRegionDashboardStoreState } from './types';

export function setIndicatorCards(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['indicatorCards']>,
) {
  state.indicatorCards = res.data;
  setRegionDashboardsLocalStorage({
    data: calculateDynamic(res.data, 'amount', 'oldAmount'),
    keyData: 'indicatorCards',
  });
}

export function setPersonInfo(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['personInfo']>,
) {
  state.personInfo = res.data;
}

export function setTopRfSubjectsEvents(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['topRfSubjectsEvents']>,
) {
  state.topRfSubjectsEvents = res.data;
}

export function setTopRfSubjectsGrowthRate(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['topRfSubjectsGrowthRate']>,
) {
  state.topRfSubjectsGrowthRate = res.data;
}

export function setEventsCountByTypes(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['eventsCountByTypes']>,
) {
  state.eventsCountByTypes = res.data;
}

export function setAgreementsCountByTypes(
  state: TRegionDashboardStoreState,
  res: TApiResponse<TRegionDashboardStoreState['agreementsCountByTypes']>,
) {
  state.agreementsCountByTypes = res.data;
}
